const mutations = {
  'SET_BUSINESSES_MONTHLY_STATES' (state, { businessesMonthlyStates, skipTimestamp = false }) {
    state.businessesMonthlyStates = businessesMonthlyStates;
    
    // Solo actualizar timestamp si NO es una actualización de websocket
    if (!skipTimestamp) {
      state.lastLocalUpdate = Date.now();
    }
  },
  
  'SET_BUSINESSES_MONTHLY_STATES_FROM_WEBSOCKET' (state, { businessesMonthlyStates }) {
    // Solo aplicar la actualización del websocket si:
    // 1. No hay actualizaciones pendientes
    // 2. Han pasado más de 2 segundos desde la última actualización local
    const timeSinceLastUpdate = state.lastLocalUpdate ? Date.now() - state.lastLocalUpdate : Infinity;
    
    if (state.pendingUpdates === 0 && timeSinceLastUpdate > 2000) {
      state.businessesMonthlyStates = businessesMonthlyStates;
    } else {
      console.log('⏸️  Ignorando actualización de websocket (hay cambios locales recientes)');
    }
  },
  
  'INCREMENT_PENDING_UPDATES' (state) {
    state.pendingUpdates++;
  },
  
  'DECREMENT_PENDING_UPDATES' (state) {
    if (state.pendingUpdates > 0) {
      state.pendingUpdates--;
    }
  }
}

export default mutations